import { defineComponent as n, inject as s, renderSlot as c, createVNode as l } from "vue";
import { ROOT_PICKER_INJECTION_KEY as i } from "./index632.js";
import { basicCellProps as p } from "./index968.js";
import { useNamespace as m } from "./index559.js";
var v = /* @__PURE__ */ n({
  name: "ElDatePickerCell",
  props: p,
  setup(o) {
    const t = m("date-table-cell"), {
      slots: a
    } = s(i);
    return () => {
      const {
        cell: e
      } = o;
      return c(a, "default", {
        ...e
      }, () => {
        var r;
        return [l("div", {
          class: t.b()
        }, [l("span", {
          class: t.e("text")
        }, [(r = e?.renderText) != null ? r : e?.text])])];
      });
    };
  }
});
export {
  v as default
};
